__turbopack_context__.v({
  "applied": "job-card-module-scss-module__0-HI-W__applied",
  "compact": "job-card-module-scss-module__0-HI-W__compact",
  "company": "job-card-module-scss-module__0-HI-W__company",
  "company-pic": "job-card-module-scss-module__0-HI-W__company-pic",
  "date-posted": "job-card-module-scss-module__0-HI-W__date-posted",
  "early-apply": "job-card-module-scss-module__0-HI-W__early-apply",
  "grid": "job-card-module-scss-module__0-HI-W__grid",
  "header": "job-card-module-scss-module__0-HI-W__header",
  "highlight": "job-card-module-scss-module__0-HI-W__highlight",
  "highlighted-paragraph": "job-card-module-scss-module__0-HI-W__highlighted-paragraph",
  "info": "job-card-module-scss-module__0-HI-W__info",
  "job-card-description": "job-card-module-scss-module__0-HI-W__job-card-description",
  "job-details": "job-card-module-scss-module__0-HI-W__job-details",
  "location": "job-card-module-scss-module__0-HI-W__location",
  "one-tap-apply": "job-card-module-scss-module__0-HI-W__one-tap-apply",
  "option-message": "job-card-module-scss-module__0-HI-W__option-message",
  "option-message-hr": "job-card-module-scss-module__0-HI-W__option-message-hr",
  "salary": "job-card-module-scss-module__0-HI-W__salary",
  "save": "job-card-module-scss-module__0-HI-W__save",
  "search-result": "job-card-module-scss-module__0-HI-W__search-result",
  "title": "job-card-module-scss-module__0-HI-W__title",
});
